module.exports = __webpack_public_path__ + "img/mira_750m_list.2641cba4.jpg";